import React, { useState, useEffect } from 'react';
import apiUrl from '../../Apiurl';
import SchedaProdotto from '../../SchedaProdotto';
import ColonnaBrand from './ColonnaBrand';
import SubHeaderDB from './SubHeaderDB';
import ListaProdottiBrandDBperScheda from './ListaProdottiBrandDBperScheda';

function DBconSchedaProd(props) {

    const product = props.product;
    const charCount = props.charCount;
    const setProductFunction = props.setProductFunction;
    const utente = props.utente
    const tradPermessa = props.tradPermessa


    const [brandSelezionato, setBrandSelezionato] = useState("TUTTI - prodotti dal più recente");
    const [listaProdottiBrand, setListaProdottiBrand] = useState([]);


    useEffect(() => {
        //copiare anche qui la stessa cosa che fa la funz da tradurre o non far visualizzare niente
        fetch(apiUrl + "/prodotti/show/all/last/100")
            .then(resp => resp.json())
            .then(data => setListaProdottiBrand(data))
    }, []);


    return (
        <div class="center sfondoBiancoTema">
            <div className='subHeader'>
                <SubHeaderDB titolo={brandSelezionato} charCount={charCount} charLimit={props.charLimit} charCountLoading={props.charCountLoading} charCountError={props.charCountError}/>
            </div>
            <div class="cf contentSubSubHeader">
                <div class="fl w-20 w-10-ns ">
                    <ColonnaBrand
                        brandSelezionato={brandSelezionato}
                        setBrandSelezionato={setBrandSelezionato}
                        setBrandFunction={setBrandSelezionato}
                        setListaProdottiBrand={setListaProdottiBrand}
                    />
                </div>
                <div class="fl w-80 w-60-ns pl2 pr2">
                    <ListaProdottiBrandDBperScheda
                        brand={brandSelezionato}
                        setProductFunction={setProductFunction}
                        listaProdottiBrand={listaProdottiBrand}
                        setListaProdottiBrand={setListaProdottiBrand}
                        /* codiceVS={product.codiceVS} */
                        tradPermessa={tradPermessa}
                        utente={utente}
                    />
                </div>
                <div class="fl w-100 w-30-ns colonnaTuttaPagina sezioneConScroll">
                    {product !== "no data" && <SchedaProdotto className="" prodotto={product} lang="it" html={false} />}
                </div>
            </div>
        </div>

    )
}


export default DBconSchedaProd;
